import React from 'react'
import './ContainerBlock.scss'

const ContainerBlock = ({ block, Block }) => {
  return (
    <div className="block block-container">
      {block.Heading && <h2>{block.Heading}</h2>}
      {block.ChildBlocks && block.ChildBlocks.length > 0 && (
        <div className="container-children">
          {block.ChildBlocks
            .sort((a, b) => a.SortOrder - b.SortOrder)
            .map((child, index) => (
              <Block key={child.Id || index} block={child} />
            ))}
        </div>
      )}
    </div>
  )
}

export default ContainerBlock
